"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Tooltip as AriaTooltip, TooltipTrigger as AriaTooltipTrigger, composeRenderProps, type TooltipProps as AriaTooltipProps } from "react-aria-components";
import { cn } from "@/utils/cn";
const TooltipTrigger = AriaTooltipTrigger;
const Tooltip = t0 => {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      offset: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const offset = t1 === undefined ? 4 : t1;
  let t2;
  if ($[4] !== className) {
    t2 = composeRenderProps(className, _temp);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== offset || $[7] !== props || $[8] !== t2) {
    t3 = <AriaTooltip offset={offset} className={t2} {...props} />;
    $[6] = offset;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export { Tooltip, TooltipTrigger };
function _temp(className_0) {
  return cn("z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0", "data-[entering]:zoom-in-95", "data-[exiting]:animate-out data-[exiting]:fade-out-0 data-[exiting]:zoom-out-95", "data-[placement=bottom]:slide-in-from-top-2 data-[placement=left]:slide-in-from-right-2 data-[placement=right]:slide-in-from-left-2 data-[placement=top]:slide-in-from-bottom-2", className_0);
}